// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"jf-z","play":"kf-z"};